export const CLASS_NAME = 'cst-page-dashboard'
export const DOCUMENT_TITLE = 'Dashboard'
export const PATH = '/'
